import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import TextCell from './TextCell';
import SortHeaderCell from './SortHeaderCell';
import { Table, Column, Cell } from 'fixed-data-table';
import * as actions from '../redux/actions';
import Util from '../Util';
import DataTableUtil from '../DataTableUtil';
import Storage from '../Storage';
import { SortTypes } from '../Constants';
import BaseLayout from './pages/BaseLayout';

const FILTER_COLUMNS = [
  'role',
  'context',
  'description',
  'menupage',
  'controller',
  'action',
  'isDisabled',
];
const DEFAULT_COL_SORT_DIRS = { role: SortTypes.DESC };
const DEFAULT_TABLE_WIDTH = 1276;
const DEFAULT_TABLE_HEIGHT = 500;

function getFilterKey(tableTitle = 'SosdbRoleActionTable') {
  return tableTitle + ' : filterText';
}

function getColSortKey(tableTitle = 'SosdbRoleActionTable') {
  return tableTitle + ' : columnSortDirs';
}

class SosdbRoleActionTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterText: Storage.getSessionItem(getFilterKey(props.tableTitle)) || '',
      columnSortDirs: Storage.getSessionItem(getColSortKey(props.tableTitle)) || DEFAULT_COL_SORT_DIRS,
    };

    this.handleSortChange = this.handleSortChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.getSosdbRoleActionList());
  }

  handleSortChange(columnKey, sortDir) {
    let value = { [columnKey]: sortDir };
    this.setState({ columnSortDirs: value }, () => {
      Storage.setSessionItem(getColSortKey(this.props.tableTitle), value);
    });
  }

  handleFilter(e) {
    if (!e.target.value) {
      this.setState({ filterText: '' }, () => {
        Storage.setSessionItem(getFilterKey(this.props.tableTitle), '');
      });
      return;
    }

    const filterBy = this.refs.filterInput.value.toLowerCase();
    this.setState({ filterText: filterBy }, () => {
      Storage.setSessionItem(getFilterKey(this.props.tableTitle), filterBy);
    });
  }

  handleEditSosdbRoleAction(id) {
    console.log('edit role action', id);
    browserHistory.push(`/roleaction/edit/${id}`);
  }

  handleSosdbRoleActionCreate() {
    console.log('create new role action');
    browserHistory.push('/roleaction/create');
  }

  render() {
    const { filterText, columnSortDirs } = this.state;
    const { roleActionList } = this.props;

    const dataList = DataTableUtil.filterList(
      roleActionList,
      filterText,
      FILTER_COLUMNS,
      columnSortDirs
    );
    const size = roleActionList.length;

    // console.log(this.props.tableTitle + ' render: ' + new Date().toLocaleString());
    let tableWidth = this.props.tableWidth || DEFAULT_TABLE_WIDTH;
    let tableHeight = BaseLayout.calcTableHeight(roleActionList) || DEFAULT_TABLE_HEIGHT;

    return (
      <div>
        <div style={{ display: 'block', margin: '20px auto', width: tableWidth }}>
          <div className='pure-g pure-u-1 card-label button-secondary'>
            <button
              className='pure-button button-title button-aux'
              onClick={this.handleSosdbRoleActionCreate.bind(this)}
            >
              <i className='fa fa-fw fa-plus' />
            </button>
            <i className='fa fa-fw fa-group' />
            {this.props.tableTitle}
            <input
              className='table-search'
              type='search'
              placeholder='Search'
              ref='filterInput'
              value={filterText}
              onChange={this.handleFilter}
            />
          </div>
          <Table
            rowsCount={dataList.length}
            rowHeight={50}
            headerHeight={50}
            width={tableWidth}
            height={tableHeight}
            {...this.props}
          >
            <Column
              header={<Cell>#</Cell>}
              cell={(props) => (
                <Cell {...props}>
                  <span style={{ fontSize: 10 }}>{props.rowIndex + 1}</span>
                </Cell>
              )}
              fixed={true}
              width={46}
              align='center'
            />
            <Column
              columnKey='role'
              header={
                <SortHeaderCell onSortChange={this.handleSortChange} sortDir={columnSortDirs.role}>
                  Role
                </SortHeaderCell>
              }
              cell={(props) => (
                <Cell
                  {...props}
                  style={{ cursor: 'pointer', color: 'blue' }}
                  onClick={this.handleEditSosdbRoleAction.bind(this, dataList[props.rowIndex].id)}
                >
                  {dataList[props.rowIndex].role}
                </Cell>
              )}
              fixed={true}
              width={250}
            />
            <Column
              columnKey='context'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.context}
                >
                  Context
                </SortHeaderCell>
              }
              cell={<TextCell className='main-cell' dataList={dataList} field='context' />}
              fixed={true}
              width={180}
            />
            <Column
              columnKey='description'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.description}
                >
                  Description
                </SortHeaderCell>
              }
              cell={<TextCell className='main-cell' dataList={dataList} field='description' />}
              fixed={true}
              width={180}
            />
            <Column
              columnKey='menupage'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.menupage}
                >
                  Menu Page
                </SortHeaderCell>
              }
              cell={<TextCell className='main-cell' dataList={dataList} field='menupage' />}
              fixed={true}
              width={180}
            />
            <Column
              columnKey='controller'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.controller}
                >
                  Controller
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='controller' />}
              fixed={true}
              width={180}
            />
            <Column
              columnKey='action'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.action}
                >
                  Action
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='action' />}
              fixed={true}
              width={180}
            />
            <Column
              columnKey='isDisabled'
              header={
                <SortHeaderCell
                  onSortChange={this.handleSortChange}
                  sortDir={columnSortDirs.isDisabled}
                >
                  Disabled
                </SortHeaderCell>
              }
              cell={<TextCell dataList={dataList} field='isDisabled' isYN={true} />}
              fixed={true}
              width={80}
            />
          </Table>
          <div className='pure-g' style={{ padding: '5px 0' }}>
            <div className='pure-u-1-3'>
              {dataList.length < size ? (
                <span>
                  Showing {dataList.length} entries (filtered from {size} total entries)
                </span>
              ) : (
                <span>
                  Showing {dataList.length} of {size}
                </span>
              )}
            </div>
            <div className='pure-u-1-3'></div>
            <div className='pure-u-1-3' style={{ textAlign: 'right' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default SosdbRoleActionTable;



// WEBPACK FOOTER //
// ./src/components/SosdbRoleActionTable.js